import { Component, OnInit, Renderer2, Output, EventEmitter } from '@angular/core';
import templateString from './templatePeriodAccumulationTypeForm.component.html';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { TemplatePeriodAccumulationType } from '../../../models/templatePeriodAccumulationType.model';
import { HttpClient } from '@angular/common/http';

@Component({
  standalone: false,
  template: templateString
})
export class TemplatePeriodAccumulationTypeFormComponent implements OnInit {
    @Output() action = new EventEmitter();
	
	public templatePeriodAccumulationTypeId: any;
	public schedulePeriodId: any;

	public templatePeriodAccumulationType: any;
	public submitted: boolean;	
	public actionTitle: string;
	public tasks: any;
	public isLoading: boolean;

    constructor(
        private http: HttpClient,
        private bsModalRef: BsModalRef,
        private renderer: Renderer2,
        private toastr: ToastrService
	) {
		this.renderer.addClass(document.body, 'md-skin');
		this.renderer.addClass(document.body, 'landing-page');
		this.renderer.addClass(document.body, 'fixed-nav');
	}

	deleteTaskId(index) {
		this.templatePeriodAccumulationType.task_ids.splice(index, 1);;
	}
	
	addTaskId() {
		this.templatePeriodAccumulationType.task_ids.push(null);
	}

  	ok(isValid) {
		this.submitted = true;
		
		if (isValid) {
			if (this.templatePeriodAccumulationTypeId === null) {
				this.templatePeriodAccumulationType.schedule_period_id = this.schedulePeriodId;

				this.http.post("template_period_accumulation_types", this.templatePeriodAccumulationType).subscribe(() => {
					this.action.emit(true);
					this.bsModalRef.hide();
				}, (response) => {
					this.toastr.error(response.error.error);
				});
			} else {
				this.http.put("template_period_accumulation_types/" + this.templatePeriodAccumulationType.id, this.templatePeriodAccumulationType).subscribe(() => {
					this.action.emit(true);
					this.bsModalRef.hide();
				}, (response) => {
					this.toastr.error(response.error.error);
				});
			}
		}
  	}

  	cancel() {
		this.bsModalRef.hide();
  	}
	
	trackByFunction(index) {
		return index;
	}

    ngOnInit() {
		if (this.templatePeriodAccumulationTypeId === null) {
			this.actionTitle = "toevoegen";
			this.templatePeriodAccumulationType = new TemplatePeriodAccumulationType();
			this.templatePeriodAccumulationType.task_ids = [];
		} else {
			this.actionTitle = "wijzigen";
			this.http.get("template_period_accumulation_types/" + this.templatePeriodAccumulationTypeId).subscribe(x => {
				this.templatePeriodAccumulationType = x;
				this.templatePeriodAccumulationType.task_ids = this.templatePeriodAccumulationType.tasks.map(function(y) { return y.id; });
			});
		}
		
		this.http.get<any>("tasks", { params: { schedule_period_id: this.schedulePeriodId } }).subscribe(tasks => {
			this.tasks = tasks;
	
			tasks.forEach(function(task) {
				task.nameWithEquivalencePosition = task.name + (task.equivalence_position == null ? "" : " (" + task.equivalence_position + ")");
			});
	
			this.isLoading = false;
		});
    }
}
